(() => {
  const initFormatModals = (scope = document) => {
    scope.querySelectorAll('[data-cp-format-root]').forEach((root) => {
      const dialog = root.querySelector('[data-cp-format-modal]');
      const opener = root.querySelector('[data-cp-format-modal-open]');
      const closer = root.querySelector('[data-cp-format-modal-close]');

      if (!dialog || !opener || dialog.dataset.cpModalReady === 'true') return;
      dialog.dataset.cpModalReady = 'true';

      opener.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });

      closer?.addEventListener('click', () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      });

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFormatModals(), { once: true });
  } else {
    initFormatModals();
  }

  document.addEventListener('shopify:section:load', (event) => initFormatModals(event.target));
})();
